import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface YmmeServiceResult {
    returnedValue?: string;
}
const shippingUrl = "api/v1/search/ymm";

export async function getYmmeMakes(): Promise<ServiceResult<YmmeServiceResult>> {
    try {
        const returnedValue = await get<any>(`${shippingUrl}/makes/`); // TODO: Wrong type any
        return {
            result: returnedValue.makes,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getYmmeModels(make: string): Promise<ServiceResult<YmmeServiceResult>> {
    if (make === "") {
        return {
            successful: false,
            errorMessage: "No parameter received",
        };
    }
    try {
        const returnedValue = await get<any>(`${shippingUrl}/models/?vehicle.make=${make}`); // TODO: Wrong type any
        return {
            result: returnedValue.models,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getYmmeYears(
    make: string,
    model: string,
    engine: string,
): Promise<ServiceResult<YmmeServiceResult>> {
    if (make === "" || model === "") {
        return {
            successful: false,
            errorMessage: "No parameter received",
        };
    }
    try {
        const returnedValue = await get<any>(
            `${shippingUrl}/years/?vehicle.make=${make}&vehicle.model=${model}&vehicle.engine=${engine}`,
        ); // TODO: Wrong type any
        return {
            result: returnedValue.years,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
export async function getYmmeEngines(
    make: string,
    model: string,
    year: string,
): Promise<ServiceResult<YmmeServiceResult>> {
    if (make === "" || model === "") {
        return {
            successful: false,
            errorMessage: "No parameter received",
        };
    }
    try {
        const returnedValue = await get<any>(
            `${shippingUrl}/engines/?vehicle.make=${make}&vehicle.model=${model}&vehicle.year=${year}`,
        ); // TODO: Wrong type any
        return {
            result: returnedValue.engines,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
